import { render, staticRenderFns } from "./Dental.vue?vue&type=template&id=6fb00ad3&scoped=true"
import script from "./Dental.vue?vue&type=script&lang=js"
export * from "./Dental.vue?vue&type=script&lang=js"
import style0 from "./Dental.vue?vue&type=style&index=0&id=6fb00ad3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb00ad3",
  null
  
)

export default component.exports